export enum LeaveType {
    Adoption = 'Adoption',
    AttendMilitaryEvent = 'AttendMilitaryEvent',
    BondingLeave = 'BondingLeave',
    EmployeeIllness = 'EmployeeIllness',
    EmployeeInjury = 'EmployeeInjury',
    FamilyCare = 'FamilyCare',
    MilitaryCare = 'MilitaryCare',
    Pregnancy = 'Pregnancy',
    Other = 'Other',
    PPL = 'PPL'
}